import React from 'react';
import { useTranslation } from 'react-i18next';

export function WidgetStatus ({ type, text }) {
    const { t } = useTranslation();
    const formattedText = /\..*\./.test(text) ? t(text) : text;
    return (<span className={`label label-${type} label-pill label-inline`}>{formattedText}</span>);
}

// Set display names for debugging.
if (process.env.NODE_ENV !== 'production') {
    WidgetStatus.displayName = 'WidgetStatus';
}
